import * as z from 'zod'

import { UTMDataSchema } from '@/lib/gtm'

export const schema = z.object({
  name: z.string().nonempty({ message: 'กรุณาใส่ชื่อของท่าน' }),
  email: z
    .string()
    .nonempty({ message: 'กรุณาใส่อีเมลของท่าน' })
    .email({ message: 'อีเมลไม่ถูกต้อง' }),
  tel: z
    .string()
    .regex(/^\d{10}$/, 'กรุณากรอกหมายเลขโทรศัพท์ 10 หลัก')
    .nonempty({ message: 'กรุณาใส่เบอร์โทรศัพท์ของท่าน' }),
  companyName: z.string().nonempty({ message: 'กรุณากรอกชื่อบริษัท' }),
  description: z.string(),
  acceptedTerm: z.boolean(),
  agreedToMarketingConsent: z.boolean(),
  url: z.string(),
  turnstileToken: z
    .string()
    .nonempty({ message: 'กรุณายืนยันว่าคุณไม่ใช่บอท' }),
})

export type FormValue = z.infer<typeof schema>

export const payloadSchema = schema.extend({
  utm: UTMDataSchema,
})

export type PayloadValue = z.infer<typeof payloadSchema>
